import React, { useMemo } from 'react'
import { Tooltip } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faExclamationCircle } from '@fortawesome/pro-solid-svg-icons'
import { ColorsPalette } from '../../../../config/colors'

export const DESIDERATA = 'DESIDERATA'
export const OUTSIDE_OF_INTERNSHIP_TIME = 'OUTSIDE_OF_INTERNSHIP_TIME'
export const MODIFIED_SHIFT_TIME = 'MODIFIED_SHIFT_TIME'

const DESIDERATA_VALUES = {
  className: 'desiderata-warning-icon',
  style: { color: '#3c8dbc' },
  title: 'Student desiderata'
}

const OUTSIDE_OF_INTERNSHIP_TIME_VALUES = {
  className: 'outside-of-internship-time-icon',
  style: { color: ColorsPalette.FIRST },
  title: 'Outside of internship schedule'
}

const MODIFIED_SHIFT_TIME_VALUES = {
  className: 'modified-shift-time-icon',
  style: { color: '#f39c12' },
  title: 'warning.modified_shift_time'
}

const ValidationWarning = ({ t, warningType }) => {
  const warningValues = useMemo(() => {
    if (warningType === DESIDERATA) {
      return DESIDERATA_VALUES
    } else if (warningType === OUTSIDE_OF_INTERNSHIP_TIME) {
      return OUTSIDE_OF_INTERNSHIP_TIME_VALUES
    } else if (warningType === MODIFIED_SHIFT_TIME) {
      return MODIFIED_SHIFT_TIME_VALUES
    }
    return {}
  }, [warningType])

  return (
    <Tooltip placement='right' title={t(warningValues.title)}>
      <span className={warningValues.className}>
        <FontAwesomeIcon icon={faExclamationCircle} style={warningValues.style} />
      </span>
    </Tooltip>
  )
}

export default ValidationWarning
